import { fetchPointsBurnLuxeTiers } from 'lib/clients/fetchPointsBurnLuxeTiers';
import * as actions from 'store/pointsBurnLuxe/pointsBurnLuxeActions';
import { createAsyncLogic } from 'lib/logic';
import { apiRequestFailure } from 'store/error/errorActions';

export const fetchPointsBurnLuxeLogic = createAsyncLogic({
  type: actions.fetchPointsBurnLuxeTiers,
  latest: true,
  async process(_, dispatch) {
    const pointsTierInstance = await fetchPointsBurnLuxeTiers();
    if (pointsTierInstance?.levels && pointsTierInstance?.name) {
      dispatch(actions.setPointsBurnLuxeTiers(pointsTierInstance));
    }
  },
  onError({ parsedError }, dispatch) {
    dispatch(apiRequestFailure(parsedError));
  },
});
